import { useCustomContactFormSlidePanel } from '@frontend/create-contact-panel';
import { useTranslation } from '@frontend/i18n';
import { formatPhoneNumber, formatPhoneNumberWithoutCountryCode } from '@frontend/phone-numbers';
import { useThreadHeaderContext, type ThreadHeaderSize } from '@frontend/thread-header-context';
import { InboxPrefixes } from '@frontend/tracking-prefixes';
import { Avatar, Button, Text } from '@frontend/design-system';
import { type ContactListItemVariant } from './contact-list-item';
import {
  unknownContactContentStyles,
  unknownContactItemBaseStyles,
  unknownContactItemNormalStyles,
  unknownContactItemSmallStyles,
  unknownContactGroupVariantStyles,
  unknownContactNameTextSizeByVariant,
} from './unknown-contact-list-item.styles';

type UnknownContactListItemProps = {
  phoneNumber: string;
  size?: ThreadHeaderSize;
  variant?: ContactListItemVariant;
};

export const UnknownContactListItem = ({
  phoneNumber,
  size = 'normal',
  variant = 'standard',
}: UnknownContactListItemProps) => {
  const { t } = useTranslation('thread-header');
  const { groupId } = useThreadHeaderContext();
  const { setShow } = useCustomContactFormSlidePanel();
  const nameTextSize = unknownContactNameTextSizeByVariant[variant];

  return (
    <li
      css={[
        unknownContactItemBaseStyles,
        size === 'normal' ? unknownContactItemNormalStyles : unknownContactItemSmallStyles,
        variant === 'group' && unknownContactGroupVariantStyles,
      ]}
    >
      <div css={unknownContactContentStyles}>
        <Avatar size='small' />
        <Text size={nameTextSize}>{formatPhoneNumber(phoneNumber)}</Text>
      </div>
      <Button
        iconName='plus-small'
        variant='secondary'
        onClick={() => {
          setShow({
            show: true,
            context: {
              mode: 'create',
              person: {
                MobilePhone: formatPhoneNumberWithoutCountryCode(phoneNumber),
              },
              locationId: groupId,
            },
          });
        }}
        label={t('Add')}
        size='small'
        trackingId={`${InboxPrefixes.Thread}-associated-contact-add-contact`}
      />
    </li>
  );
};
